import React, { Component } from 'react'
import {
    Row,
    Col,
    Select,
    List,
    Button,
    Input,
    Popconfirm,
    Modal,
    Table,
    Pagination,
    Spin,
    Card,
    InputNumber
} from 'antd'
import { api, app, config } from '../../app'
import utils from '../../utils'
import TrainSelUser from '../../components/TrainSelUser'
import NTrainSignList from './NTrainSignList'

const Option = Select.Option

/**
 * 判断审核
 * @param audit
 * @returns {string}
 */
function checkAudit (audit) {
    switch (audit) {
        case '0':
            return '未审核'
        case '1':
            return '已通过'
        case '2':
            return '不通过'
    }
}


class NTrainReleaseList extends Component {
    constructor (props) {
        super(props)
        this.state = {
            page: 1,
            total: 0,
            detailInfo: {},
            beInfo: {},
            trainList: [],
            playerList: [],
            beClass: [],
            class_id: '',
            search_val: '',
            player_train_id: '',
            player_is_class: '0',
            player_is_certificate: null,
            list_visible: false
        }
    }

    componentDidMount () {
        this._isMounted = true
        this.dataSource(1)
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    /**
     * 设置值
     * @param data
     */
    setData = (data) => app.setStateSync(this, data)

    /**
     * 数据加载
     * @returns {Promise<void>}
     */
    dataSource = async (now_page) => {
        await this.setData({ data_loading: true })
        const { class_id, search_val } = this.state,
            params = {
                class_id,
                search_val,
                page: now_page,
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }
        let { flag, data, msg, total } = await app.post(api.PublishTrainList, params)
        if (flag === 1) {
            if (this.state.page === now_page) {
                await this.setData({
                    data_loading: false,
                    trainList: utils.addArrayKey(data),
                    total: parseInt(total || 0)
                })
            }
        } else {
            app.alert(msg, 'error')
        }
    }

    /**
     * 打开选人报名人员列表
     */
    openSelListModal = (train_id) => {
        this.setData({ selUserId: train_id, selList_visible: true })
    }

    /**
     * 关闭选人报名人员列表
     */
    closeSelListModal = () => {
        this.setData({ selUserId: '', selList_visible: false })
    }

    /**
     * 关闭报名人员列表
     */
    closeListModal = () => {
        this.setData({ list_visible: false })
    }

    /**
     * 打开报名人员列表
     */
    openListModal = async (player_train_id, player_is_class, player_is_certificate) => {
        await this.setData({
            list_visible: true,
            player_train_id,
            player_is_class,
            player_is_certificate: player_is_certificate + ''
        })
    }

    /**
     * 关闭详情
     */
    closeDetailModal = () => {
        this.setData({ detail_visible: false, detail_loading: false, detailInfo: {} })
    }

    /**
     * 打开详情
     */
    openDetailModal = async (train_id) => {
        await this.setData({ train_id, detail_visible: true, detail_loading: true })
        const params = {
            train_id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg } = await app.post(api.PublishTrainDetails, params)
        if (flag !== 1) {
            app.alert(msg, 'error')
            data = {}
        }
        await this.setData({ detailInfo: data, detail_loading: false })
    }

    /**
     * 筛选条件变更
     * @param e
     */
    handleFilterChange = async (e) => {
        await this.setData({ class_id: e, page: 1 })
        await this.dataSource(1)
    }

    /**
     * 搜索
     * @param search_val
     */
    handleSearch = async (search_val) => {
        await this.setData({ search_val, page: 1 })
        await this.dataSource(1)
    }

    /**
     * 取消任务
     */
    handleDetele = async (train_id) => {
        const params = {
            train_id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, msg } = await app.post(api.TrainCancel, params)
        if (flag === 1) {
            app.alert('取消成功~', 'success')
            await this.setData({ page: 1 })
            await this.dataSource(1)
        } else {
            app.alert(msg, 'error')
        }
    }

    /**
     * 跳转发布/编辑
     * @param id
     */
    handleToEdit = (id) => {
        let param = ''
        if (id) {
            param = '/' + id
        }
        this.props.history.replace('/notice/train-release' + param)
    }

    /**
     * 分页
     */
    handlePageChange = async (page) => {
        await this.setData({ page })
        await this.dataSource(page)
    }

    /**
     * 开始/结束 培训处理
     * @param train_id
     * @param is_class
     * @param type
     * @param class_id
     * @returns {Promise<void>}
     */
    handleBETrain = async (train_id, is_class, type) => {
        let params = {
            train_id,
            is_class,
            type,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        if (is_class === 1) {
            let { be_class_id } = this.state
            if (!be_class_id) {
                app.alert('请选择操作班级！', 'warn')
                return
            }
            params.class_id = be_class_id
        }
        let { flag, msg } = await app.post(api.StartTrain, params)
        if (flag === 1) {
            app.alert('操作成功', 'success')
            if (is_class === 1) {
                this.handleCloseBEModal()
            }
            await this.dataSource(this.state.page)
        } else {
            app.alert(msg, 'warn')
        }
    }

    /**
     * 打开
     * @param train_id
     * @param type
     */
    handleOpenBEModal = async (train_id, type) => {
        await this.setData({ be_visible: true, be_loading: true, beInfo: { train_id, type }, beClass: [] })
        let params = {
            train_id,
            type,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg } = await app.post(api.StartTrainClassList, params)
        if (flag === 1) {
            await this.setData({ beClass: data, be_loading: false })
        } else {
            app.alert(msg, 'warn')
        }
    }

    /**
     * 关闭
     */
    handleCloseBEModal = () => {
        this.setData({ be_visible: false, be_loading: false })
    }

    /**
     * 发布状态操作按钮
     * @param id
     * @param status
     * @returns {*}
     */
    checkPushState = ({ train_id, publish_status, train_status, is_class }) => {
        let btn = null
        if (publish_status === '0') {
            btn = (
                <Popconfirm placement="top" okType="danger"
                            title="是否取消此培训任务吗？"
                            onConfirm={() => this.handleDetele(train_id)}
                            okText="是" cancelText="否">
                    <Button size="small" type="danger" className="btn"
                            ghost>取消培训</Button>
                </Popconfirm>
            )
        } else if (publish_status === '1') {
            if (train_status === '2') {
                btn = (<Button size="small" className="btn" disabled>培训已结束</Button>)
            } else {
                if (is_class === '1') {
                    btn = [
                        (<Button size="small" key={1} className="btn" onClick={async () => {
                            if (is_class === '1') {
                                this.handleOpenBEModal(train_id, 1)
                            } else {
                                await this.handleBETrain(train_id, 0, 1)
                            }
                        }}>开始培训</Button>),
                        (<Button size="small" key={2} className="btn" onClick={async () => {
                            if (is_class === '1') {
                                this.handleOpenBEModal(train_id, 2)
                            } else {
                                await this.handleBETrain(train_id, 0, 2)
                            }
                        }}>结束培训</Button>)
                    ]
                } else {
                    if (train_status === '0') {
                        btn = (<Button size="small" className="btn" onClick={async () => {
                            if (is_class === '1') {
                                this.handleOpenBEModal(train_id, 1)
                            } else {
                                await this.handleBETrain(train_id, 0, 1)
                            }
                        }}>开始培训</Button>)
                    } else if (train_status === '1') {
                        btn = (<Button size="small" className="btn" onClick={async () => {
                            if (is_class === '1') {
                                this.handleOpenBEModal(train_id, 2)
                            } else {
                                await this.handleBETrain(train_id, 0, 2)
                            }
                        }}>结束培训</Button>)
                    }
                }
            }
        } else if (publish_status === '2') {
            btn = (<Button size="small" className="btn" disabled>已取消</Button>)
        }
        return btn
    }

    render () {
        let {
            data_loading, trainList, selUserId, selList_visible, list_visible, detail_visible, detail_loading, be_class_id,
            detailInfo, page, total, train_id, be_visible, be_loading, beInfo, beClass, player_train_id, player_is_class, player_is_certificate
        } = this.state
        return (
            <div className="n-page notice-train-list">
                <div className="page-title">发布/编辑培训</div>
                <div className="page-content">
                    <Row className="page-top">
                        <Col span={12}>
                            <Select placeholder="筛选" className="filter" onChange={this.handleFilterChange}>
                                <Option value="0">全部培训</Option>
                                <Option value="1">内部培训</Option>
                                <Option value="2">外部培训</Option>
                                <Option value="3">特定培训</Option>
                            </Select>
                            <Input.Search placeholder="搜索" onSearch={this.handleSearch}
                                          style={{ width: 200, marginLeft: 20 }}/>
                        </Col>
                        <Col span={12} style={{ textAlign: 'right' }}>
                            <Button onClick={() => this.handleToEdit()}>发布培训</Button>
                        </Col>
                    </Row>
                    <div className="items" id="train-list">
                        <List
                            locale={{
                                emptyText: '暂无培训信息'
                            }}
                            loading={data_loading}
                            dataSource={trainList}
                            renderItem={(item, index) => {
                                let cla = '无', startdate = item.startdate
                                switch (item.class_id) {
                                    case '1':
                                        cla = '内部培训'
                                        break
                                    case '2':
                                        cla = '外部培训'
                                        break
                                    case '3':
                                        cla = '特定培训'
                                        break
                                }
                                return (
                                    <List.Item key={index}>
                                        <div className="train-img">
                                            <img alt="" src={config.imgUrl + item.browse_images}/>
                                        </div>
                                        <div className="train-info">
                                            <Row type="flex" align="middle">
                                                <Col span={10} className="ti-title">培训课程：{item.trainame}</Col>
                                                <Col span={14} className="ti-content">培训类型：{cla}</Col>
                                            </Row>
                                            <Row>
                                                <Col span={10} className="ti-title">培训师：{item.train_teacher}</Col>
                                                <Col span={14} className="ti-content">培训价格：<span
                                                    style={{ c19or: '#FF0000' }}>{item.train_price}</span> 元</Col>
                                            </Row>
                                            <Row>
                                                <Col span={10} className="ti-title">可获得技能：{item.train_ppe || '无'}</Col>
                                                <Col span={14} className="ti-content">已报名人数：<span
                                                    style={{ c19or: '#3399CC' }}>{item.join_number}</span> / {item.train_number}人</Col>
                                            </Row>
                                            <Row>
                                                <Col span={24} className="ti-title">
                                                    {
                                                        item.is_class === '1' ?
                                                            (`培训周期：${item.train_day}天`) : ('开始培训日期：' + startdate)
                                                    }</Col>
                                            </Row>
                                            <Row>
                                                <Col span={10} className="ti-title">报名截止日期：{item.apply_time}</Col>
                                                <Col span={14} className="ti-content">
                                                    {this.checkPushState(item)}
                                                    {
                                                        item.is_class === '1' && item.train_status !== '2' && item.publish_status !== '2' ?
                                                            (
                                                                <Button size="small"
                                                                        onClick={() => this.openSelListModal(item.train_id)}
                                                                        className="btn">选人开班</Button>
                                                            ) : null
                                                    }
                                                    <Button size="small"
                                                            onClick={() => this.handleToEdit(item.train_id)}
                                                            className="btn">编辑</Button>
                                                    <Button size="small"
                                                            onClick={() => this.openDetailModal(item.train_id)}
                                                            className="btn">详情</Button>
                                                    <Button size="small"
                                                            onClick={() => this.openListModal(item.train_id, item.is_class, item.is_certificate)}
                                                            className="btn">报名人员</Button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </List.Item>
                                )
                            }}
                        />
                        {/*报名人员列表对话框*/}
                        <Modal
                            visible={list_visible}
                            maskClosable={false}
                            width='100%'
                            style={{ top: 0, height: '100vh' }}
                            bodyStyle={{ height: 'calc(100vh - 55px)', overflow: 'auto' }}
                            zIndex={1010}
                            onCancel={this.closeListModal}
                            footer={null}
                            destroyOnClose={true}
                            title="报名人员列表"
                        >
                            <NTrainSignList train_id={player_train_id} is_class={player_is_class}
                                            is_certificate={player_is_certificate}/>
                        </Modal>
                        {/*开始/结束班级选择*/}
                        <Modal
                            visible={be_visible}
                            onCancel={this.handleCloseBEModal}
                            destroyOnClose={true}
                            width={400}
                            style={{ top: '35%' }}
                            okText="确定"
                            cancelText="取消"
                            title={<div style={{ textAlign: 'center' }}>选择操作班级</div>}
                            onOk={() => this.handleBETrain(beInfo.train_id, 1, beInfo.type)}
                            afterClose={() => {
                                this.setData({ be_class_id: undefined, beInfo: {} })
                            }}
                        >
                            <Select placeholder="选择班级" value={be_class_id} style={{ width: '100%' }}
                                    notFoundContent={be_loading ? <Spin size="small"/> : '暂无'}
                                    onChange={(be_class_id) => {
                                        this.setData({ be_class_id })
                                    }}>
                                {
                                    beClass.map((c, i) => {
                                        return (
                                            <Option key={i} value={c.id}>{c.class_name}</Option>
                                        )
                                    })
                                }
                            </Select>
                        </Modal>
                        {/*选人人员列表对话框*/}
                        <TrainSelUser id={selUserId} visible={selList_visible} close={this.closeSelListModal}/>
                        {/*培训详情对话框*/}
                        <Modal
                            visible={detail_visible}
                            onCancel={this.closeDetailModal}
                            cancelText="取消"
                            okText="修改"
                            onOk={() => this.handleToEdit(train_id)}
                            destroyOnClose={true}
                            width={800}
                            title={<div style={{ textAlign: 'center' }}>培训详情</div>}
                            className="notice-train-list-detail"
                        >
                            {
                                detail_loading ? (<Spin/>) : (
                                    <div className="items">
                                        <div className="braft-output-content"
                                             dangerouslySetInnerHTML={{ __html: detailInfo.train_content }}
                                             style={{ padding: '20px 0' }}/>
                                        <Row className="item">
                                            <Col span={4} className="title">培训课程：</Col>
                                            <Col span={19} offset={1}>{detailInfo.trainame}</Col>
                                        </Row>
                                        <Row className="item">
                                            <Col span={4} className="title">培训师：</Col>
                                            <Col span={19} offset={1}>{detailInfo.train_teacher}</Col>
                                        </Row>
                                        {
                                            detailInfo.is_class === '1' ? (
                                                <Row className="item">
                                                    <Col span={4} className="title">培训周期：</Col>
                                                    <Col span={19}
                                                         offset={1}>{detailInfo.train_day}天</Col>
                                                </Row>
                                            ) : (
                                                <Row className="item">
                                                    <Col span={4} className="title">培训时间：</Col>
                                                    <Col span={19}
                                                         offset={1}>{detailInfo.startdate + ' ~ ' + detailInfo.endate}</Col>
                                                </Row>
                                            )
                                        }
                                        <Row className="item">
                                            <Col span={4} className="title">报名截止时间：</Col>
                                            <Col span={19} offset={1}>{detailInfo.apply_time}</Col>
                                        </Row>
                                        <Row className="item">
                                            <Col span={4} className="title">培训价格：</Col>
                                            <Col span={19}
                                                 offset={1}>{parseFloat(detailInfo.train_price).toFixed(2)}</Col>
                                        </Row>
                                        <Row className="item">
                                            <Col span={4} className="title">培训人数：</Col>
                                            <Col span={19} offset={1}>{detailInfo.train_number}</Col>
                                        </Row>
                                        <Row className="item">
                                            <Col span={4} className="title">已报名人数：</Col>
                                            <Col span={19} offset={1}>{detailInfo.join_number}</Col>
                                        </Row>
                                        <Row className="item">
                                            <Col span={4} className="title">培训地点：</Col>
                                            <Col span={19} offset={1}>{detailInfo.train_site || '暂无'}</Col>
                                        </Row>
                                        <Row className="item">
                                            <Col span={4} className="title">培训级别：</Col>
                                            <Col span={19} offset={1}>
                                                {detailInfo.object === '1' ? '全国' : (detailInfo.object === '2' ? '省级' : (detailInfo.object === '3' ? '市级' : '队伍'))}
                                            </Col>
                                        </Row>
                                        <Row className="item">
                                            <Col span={4} className="title">培训装备：</Col>
                                            <Col span={19} offset={1}>{detailInfo.train_equip || '无'}</Col>
                                        </Row>
                                        <Row className="item">
                                            <Col span={4} className="title">培训技能：</Col>
                                            <Col span={19} offset={1}>{detailInfo.train_ppe || '无'}</Col>
                                        </Row>
                                        <Row className="item">
                                            <Col span={4} className="title">培训状态：</Col>
                                            <Col span={19} offset={1}>
                                                {
                                                    detailInfo.train_status === '1' ? '进行中' : (detailInfo.train_status === '2' ? '已完成' : '未开始')
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="item">
                                            <Col span={4} className="title">审核情况：</Col>
                                            <Col span={19} offset={1}>
                                                <Card bodyStyle={{ padding: 12 }} className="item-card"
                                                      title={'一级审核'}>
                                                    <div>
                                                        <div>审核人：{detailInfo.one_indexno}</div>
                                                        <div>审核状态：{checkAudit(detailInfo.one_audit)}</div>
                                                        <div>审核时间：{detailInfo.one_time || '无'}</div>
                                                        {detailInfo.one_audit === '2' ?
                                                            <div>不通过原因：{detailInfo.audit_reason}</div> : null}
                                                    </div>
                                                </Card>
                                                {
                                                    detailInfo.object === '1' ?
                                                        [
                                                            (<Card key="1" bodyStyle={{ padding: 10 }}
                                                                   className="item-card"
                                                                   title={'二级审核'}>
                                                                {
                                                                    detailInfo.two_indexno ?
                                                                        (
                                                                            <div>
                                                                                <div>审核人：{detailInfo.two_indexno}</div>
                                                                                <div>审核状态：{checkAudit(detailInfo.two_audit)}</div>
                                                                                <div>审核时间：{detailInfo.two_time || '无'}</div>
                                                                                {detailInfo.two_audit === '2' ?
                                                                                    <div>不通过原因：{detailInfo.audit_reason}</div> : null}
                                                                            </div>
                                                                        ) : '暂无审核'
                                                                }
                                                            </Card>),
                                                            (<Card key="2" bodyStyle={{ padding: 10 }}
                                                                   className="item-card"
                                                                   title={'三级审核'}>
                                                                {
                                                                    detailInfo.three_indexno ?
                                                                        (
                                                                            <div>
                                                                                <div>审核人：{detailInfo.three_indexno}</div>
                                                                                <div>审核状态：{checkAudit(detailInfo.three_audit)}</div>
                                                                                <div>审核时间：{detailInfo.three_time || '无'}</div>
                                                                                {detailInfo.three_audit === '2' ?
                                                                                    <div>不通过原因：{detailInfo.audit_reason}</div> : null}
                                                                            </div>
                                                                        ) : '暂无审核'
                                                                }
                                                            </Card>)
                                                        ] : null
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="item">
                                            <Col>
                                                {
                                                    (detailInfo.details_images || []).map((img, index) => {
                                                        return (<img key={index} src={config.imgUrl + img} alt=""
                                                                     className="d-img"/>)
                                                    })
                                                }
                                            </Col>
                                        </Row>
                                    </div>
                                )
                            }
                        </Modal>
                    </div>
                    <div className="page-tools">
                        <Pagination current={page} pageSize={20} total={total}
                                    showTotal={(total) => `总数量：${total}  `} onChange={this.handlePageChange}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default NTrainReleaseList



// WEBPACK FOOTER //
// ./src/routes/notice/NTrainReleaseList.jsx